import { render, staticRenderFns } from "./DriverDesktop.vue?vue&type=template&id=c41b0ef2&"
import script from "./DriverDesktop.vue?vue&type=script&lang=ts&"
export * from "./DriverDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports